import './ClipWrapper.css';
import React from 'react';
import PropTypes from 'prop-types';
import Clip from './Clip';

const ClipWrapper = props => {
  const { artist, category, images, videoSrc, relatedClips } = props;
  return (
    <div className='clip-ar-box-outer'>
      <div className='clip-ar-box-inner'>
        <div className='featured-clip-container'>
          <div className='featured-clip-container-overlay' />
          <Clip
            artist={artist}
            category={category}
            images={images}
            videoSrc={videoSrc}
          />
          <div className='related-clips-container'>
            <h2>VIDEOS RELACIONADOS - {category.toUpperCase()}</h2>
            <div className='related-clips-inner-container'>{relatedClips}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ClipWrapper;

ClipWrapper.defaultProps = {
  artist: '',
  category: '',
  images: {},
  relatedClips: null,
  videoSrc: null,
};

ClipWrapper.propTypes = {
  artist: PropTypes.string,
  category: PropTypes.string,
  images: PropTypes.objectOf(PropTypes.string),
  relatedClips: PropTypes.arrayOf(PropTypes.object),
  videoSrc: PropTypes.string,
};
